export default __webpack_public_path__ + "static/media/description.0f49e85b.svg";